/*
 * glasstat-swatch-groups.js  -  2026-08-21
 * ---------------------------------------------------------------------------
 * PROTOTYPE LAYER. Sorts the border-tile swatches into three labelled groups
 * (Solid Colors / Iridescent / Metallic) without editing sections/product-100.liquid.
 *
 * The finish is already encoded in each swatch's title attribute, e.g.
 *   "Aruba - METALLIC", "Bel Air Blue - IRRIDIZED", "Alpine"
 * so no new data is required.
 *
 * Swatches are MOVED with appendChild, never cloned or rebuilt via innerHTML.
 * Moving a node preserves its event listeners, so the existing click handler
 * (which writes the tile name into properties[Tile Color #N]) keeps working.
 *
 * SELECTION INDICATOR: the theme's own indicator sets opacity on an
 * <i class="fa fa-check"> and stops working once the anchors are nested, so
 * this file adds its own .gt-selected class instead, scoped per picker. That
 * is also clearer than a small checkmark at 48px.
 *
 * Remove this file, its <script> tag in theme.liquid, and the matching CSS
 * block in custom.css once product-100.liquid is rebuilt in Pass 4.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var GROUPS = [
    { key: 'solid',      label: 'Solid Colors' },
    { key: 'iridescent', label: 'Iridescent'   },
    { key: 'metallic',   label: 'Metallic'     }
  ];

  function finishOf(text) {
    if (/metallic/i.test(text)) return 'metallic';
    if (/irr?idized|iridescent/i.test(text)) return 'iridescent';
    return 'solid';
  }

  function closestAnchor(node, container) {
    while (node && node !== container) {
      if (node.tagName === 'A') return node;
      node = node.parentNode;
    }
    return null;
  }

  function wireSelection(container) {
    container.addEventListener('click', function (e) {
      var a = closestAnchor(e.target, container);
      if (!a) return;
      var all = container.getElementsByTagName('a');
      for (var i = 0; i < all.length; i++) all[i].className = all[i].className.replace(/\s*gt-selected/g, '');
      a.className = (a.className + ' gt-selected').trim();
    });
  }

  function groupContainer(container) {
    if (container.getAttribute('data-gt-grouped') === '1') return;

    var swatches = [];
    var child = container.firstElementChild;
    while (child) {
      if (child.tagName === 'A') swatches.push(child);
      child = child.nextElementSibling;
    }

    // Only act on a full picker. If the markup is not what we expect, leave it alone.
    if (swatches.length < 6) return;

    var buckets = { solid: [], iridescent: [], metallic: [] };
    swatches.forEach(function (a) {
      var label = a.getAttribute('title') || a.getAttribute('data-name') || '';
      buckets[finishOf(label)].push(a);
    });

    var frag = document.createDocumentFragment();

    GROUPS.forEach(function (g) {
      var items = buckets[g.key];
      if (!items.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'gt-swatch-group gt-swatch-group--' + g.key;

      var label = document.createElement('div');
      label.className = 'gt-swatch-group__label';
      label.textContent = g.label;

      var count = document.createElement('span');
      count.className = 'gt-swatch-group__count';
      count.textContent = items.length;
      label.appendChild(count);

      var row = document.createElement('div');
      row.className = 'gt-swatch-group__items';
      items.forEach(function (a) { row.appendChild(a); });

      wrap.appendChild(label);
      wrap.appendChild(row);
      frag.appendChild(wrap);
    });

    container.appendChild(frag);
    container.setAttribute('data-gt-grouped', '1');
    wireSelection(container);
  }

  function run() {
    var containers = document.querySelectorAll('.cp-select');
    for (var i = 0; i < containers.length; i++) groupContainer(containers[i]);
  }

  function schedule() { setTimeout(run, 250); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
})();
